<template>
  <div class="container">
    VERALTET
    <div class="card mt-6" v-if="contact">
      <div class="card-header">
        <h3 class="card-title">{{contact.displayName}}</h3>
      </div>
      <div class="card-body">
        <h1>Contact:</h1>
        <img class="user-image" :src="contact.profilePic|defaultUserPic" width="128" height="128" />
        <pre>{{contact}}</pre>
      </div>
      <div class="card-footer">
        <el-button @click.prevent="goBack" size="large">zurück</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserPage',
  data() {
    return {
      contactId: null
    };
  },
  watch: {
    $route (to, from) {
      /* check for route change if using <keep-alive>...</keep-alive> */
      if ( to.name === 'user' ) {
        this.setContactToCurrentPath();
      }
    }
  },
  created() {
    this.setContactToCurrentPath();
  },
  computed: {
    // ...mapGetters("project", [
      // "get_goal_by_id"
    // ]),

    contact() {
      return this.$models.userContact.get_contact_by_id( this.contactId )
    },

    // current_goal() {
    //   console.log("contact.currentTask", this.contact.currentTask);
    //   let current_goal = this.get_goal_by_id(this.contact.currentTask);
    //   console.log("current_goal", current_goal);
    //   return current_goal;
    // }

  },
  methods: {
    setContactToCurrentPath() {
      this.contactId = this.$route.params.userId;
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.user-image {
  border-radius: 5px;
}
</style>
